import React from 'react';

function ListBoxGroup(_ref) {
  let {
    bem,
    groupNameId,
    groupName,
    children,
    role
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, role === 'group' && groupName && (/*#__PURE__*/React.createElement("div", {
    id: groupNameId,
    "aria-hidden": "true",
    className: bem.e('group-name')
  }, groupName)), /*#__PURE__*/React.createElement("ul", {
    role: role,
    className: bem === null || bem === void 0 ? void 0 : bem.e('group'),
    "aria-labelledby": role === 'group' && groupName ? groupNameId : undefined
  }, children));
}

export { ListBoxGroup };
